<template>
    <div id="demo-basic-card" class="margin-top-overview">
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="vx-col md:w-4/12 mt-2 w-full p-0">
                    <div class="component" style="min-height:117px">
                        <div
                        class="vx-card mt-2 p-6 w-full cart-hightlight"
                        v-for="(header, indexHeader) in messageHeader" :key="indexHeader"
                        :style="{background: header.color}"
                        >
                            <div class="m-auto" style="width:70%; margin-top:-15px !important">
                                <div class="component">
                                    <span class="title-header">{{header.title}}</span>
                                </div>
                                <div class="component">
                                    <span class="content-header">{{header.content}}</span>
                                </div>
                                <div class="component">
                                    <img class="custom-image-icon" :src="header.icon" alt="">
                                </div>
                                <div class="cmponent">
                                    <img class="custom-image-vector" style = "border-radius: 0.5rem;" :src="header.vector" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vx-card mt-6 p-6 pt-2 w-full cart-data">
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="component mt-2 text-data">
                                    <span>{{$t('overview.data')}}
                                        <div v-if="!showRadialChart" class="lds-facebook">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </span>
                                </div>
                                <div class="component mt-2 text">
                                    <span>{{ $t('overview.today')}}</span>
                                </div>
                                <div class="component count-data">
                                    <span>{{eArabic(totalMentioned)}}</span>
                                </div>
                                <div class="component" style="min-height:42px">
                                    <span v-if="increaseMentioned" class="text" :style="{color: '#28C76F'}">{{percentMentioned || 0}}% </span>
                                    <span v-else class="text" :style="{color: '#F12B2C'}">{{percentMentioned || 0}}% </span>
                                    <span>{{ $t('overview.comparedToYesterday')}}</span>
                                </div>
                                <div class="component mt-2 min-button">
                                    <vs-button @click="$router.push('/user/package-upgrade-v2')">{{ $t('overview.viewDataPackages')}}</vs-button>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/2 w-full">
                                <div id="chart">
                                    <vue-apex-charts
                                    v-if="showRadialChart"
                                    type="radialBar"
                                    height="200"
                                    :options="radialChart.chartOptions"
                                    :series="radialChart.series">
                                    </vue-apex-charts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="vx-col md:w-8/12 w-full mt-2 pr-0 topic-card">
                    <div class="component">
                        <span class="text-data">{{ $t('overview.topTopic')}}
                             <div v-if="!showTopTopic" class="lds-facebook">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </span>
                        <vs-button class="ml-4" @click="$router.push('/user/v2/project-list')">{{ $t('overview.viewAllTopics')}}</vs-button>
                    </div>
                    <div class="vx-card mt-2 p-1 w-full" style="height:340px">
                        <vs-table stripe :data="defaultWords" :noDataText="this.$t('noData')" class="w-full mt-4 min-table">
                            <template>
                                <vs-tr>
                                    <vs-th class="fixed-header" v-for="(header, indexHeader) in headerTable " :key="indexHeader">
                                        <span>{{header.name}}</span>
                                    </vs-th>
                                </vs-tr>
                                <vs-tr v-for="(item, index) in defaultWords.slice(0,5)" :data="item" :key="index">
                                    <vs-td>
                                        <div class="component w-full bullet-align">
                                            <div class="component flex" v-for="(group, indexGroup) in optionGroupTopics" :key="indexGroup">
                                                <div v-if="group.value === item.topicGroupId" class="h-3 w-3 rounded-full mr-2 mt-1" :style="{background: group.circle}"></div>
                                            </div>
                                            <span>{{item.topicName}}</span>
                                        </div>
                                        <div class="component w-full" v-if="item.plus > 0">
                                            <span class="text-keyword ">{{item.keywords}}, +{{item.plus}}</span>
                                        </div>
                                        <div class="component w-full">
                                            <span class="text-keyword ">{{item.keywords}}</span>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="component w-full bullet-align">
                                            <div class="component flex" v-if="!item.isOther">
                                                <div class="h-3 w-3 rounded-full mr-2 m-top" :style="{background: item.circle}"></div>
                                                <span class="text-group">{{item.groupName}}</span>
                                            </div>
                                            <div class="component flex" v-else>
                                                <div class="h-3 w-3 rounded-full mr-2 m-top" :style="{background: item.circle}"></div>
                                                <span class="text-group">{{item.groupName}}</span>
                                            </div>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="component">
                                            <span class="text-group">{{ eArabic(item.count) }}</span>
                                        </div>
                                        <div class="component w-full">
                                            <span class="text-keyword "> 24 {{ $t('overview.hours')}}</span>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                       <div class="component">
                                            <span class="text-group">{{ eArabic(item.positive) }}</span>
                                        </div>
                                        <div class="component w-full">
                                            <span class="text-keyword percent-up" v-if="item.checkPercent"> {{item.percentPositive}}%</span>
                                            <span class="text-keyword percent-down" v-else> {{item.percentPositive}}%</span>
                                            <feather-icon class="shade-up ml-1" icon="TrendingUpIcon" v-if="item.checkPercent"></feather-icon>
                                            <feather-icon class="shade-down ml-1" icon="TrendingDownIcon" v-else></feather-icon>
                                        </div>
                                    </vs-td>
                                     <vs-td>
                                       <div class="component">
                                            <span class="text-group">{{ eArabic(item.negative) }}</span>
                                        </div>
                                        <div class="component w-full">
                                            <span class="text-keyword percent-up" v-if="item.checkPercentNegative"> {{item.percentNegative}}%</span>
                                            <span class="text-keyword percent-down" v-else> {{item.percentNegative}}%</span>
                                            <feather-icon class="shade-up ml-2" icon="TrendingUpIcon" v-if="item.checkPercentNegative"></feather-icon>
                                            <feather-icon class="shade-down ml-2" icon="TrendingDownIcon" v-else></feather-icon>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="component w-full mt-8">
                    <span class="text-data">{{ $t('overview.infomationHighlights')}}
                        <div v-if="!showData" class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </span>
                    <vs-button class="ml-2" @click="$router.push('/user/special-info')">{{ $t('overview.seeMore')}}</vs-button>
                </div>
                <div class="vx-col cart-data-topic p-0 pr-2 mb-2 md:w-3/12 w-full" v-for="(topPost, indexTopic) in listTopPost.slice(0,4)" :key="indexTopic">
                    <div class="vx-card mt-6 p-6 cart-data-topic w-full">
                        <div class="component min-height-topic">
                            <span
                                class="badge"
                                v-for="(group, indexGroup) in optionGroupTopics.filter(group => group.value == topPost.topicGroupId)"
                                :style="{background: group.bg, color: group.color}"
                                :key="indexGroup">{{group.label}}</span>
                        </div>

                        <div class="component cursor-pointer" @click="openURL(topPost)">
                            <div class="component mt-4 text-data w-full">
                                <span class="title-top-post">{{topPost.title}}</span>
                            </div>

                            <div class="component mt-2 w-full text-content-keyword">
                                <span class="content-top-post">{{topPost.content}}</span>
                            </div>
                        </div>

                        <div class="component mt-2 w-full mt-2">
                            <span class="text-keyword" >{{ $t('overview.keyword')}}</span>
                        </div>
                        <div class="component min-height-topic">
                            <span class="badge mr-1" style="background: rgba(var(--vs-warning),.15); color: #ff9f43" v-for="(key, indexKeyword) in topPost.keywords" :key="indexKeyword">{{key.keyword}}</span>
                        </div>

                        <div class="component mt-2 w-full mt-4">
                            <span class="text-keyword">{{ $t('overview.shades')}}</span>
                        </div>

                        <div class="component vx-row mt-2">
                            <div class="vx-col md:w-1/3 w-full grid-cls text-center">
                                <feather-icon icon="SmileIcon" class="color-smile m-auto" :style="{color: topPost.colorPositive}"></feather-icon>
                                <span class="ml-2">{{topPost.percentPositive}}%</span>
                            </div>

                            <div class="vx-col md:w-1/3 w-full grid-cls text-center">
                                <feather-icon icon="FrownIcon" class="color-negative m-auto" :style="{color: topPost.colorNegative}"></feather-icon>
                                <span class="ml-2">{{topPost.percentNegative}}%</span>
                            </div>

                            <div class="vx-col md:w-1/3 w-full grid-cls text-center">
                                <feather-icon icon="MehIcon" class="color-neutral m-auto" :style="{color: topPost.colorNeutral}"></feather-icon>
                                <span class="ml-2">{{topPost.percentNeutral}}%</span>
                            </div>
                        </div>

                        <div class="component vx-row mt-6">
                            <div class="vx-col md:w-1/3 w-full p-0 pr-1 mt-2">
                                <div class="w-full component badge sub-component " style="background: rgba(var(--vs-dark),.1); color: #F8F8F8">
                                    <span class="text-sub-component">{{ $t('overview.interactive')}}</span>
                                    <b class="count-sub-component mt-2">{{ eArabic(topPost.interactive) || 0}}</b>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 w-full p-0 pr-1 mt-2">
                                <div class="w-full component badge sub-component " style="background: rgba(var(--vs-dark),.1); color: #F8F8F8">
                                    <span class="text-sub-component">{{ $t('overview.comment')}}</span>
                                    <b class="count-sub-component mt-2">{{ eArabic(topPost.comment) || 0}}</b>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 w-full p-0 mt-2">
                                <div class="w-full component badge sub-component " style="background: rgba(var(--vs-dark),.1); color: #F8F8F8">
                                    <span class="text-sub-component">{{ $t('overview.share')}}</span>
                                    <b class="count-sub-component mt-2">{{ eArabic(topPost.share) || 0}}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import neutral from '@/assets/images/pages/neutral.png';
import neutralIcon from '@/assets/images/pages/neutral-icon.png'
import warning from '@/assets/images/pages/warning.png';
import warningIcon from '@/assets/images/pages/warning-icon.png'
import tipIcon from '@/assets/images/pages/tip.png'
import tip from '@/assets/images/pages/Bubble.png';
import positive from '@/assets/images/pages/positive.png';
import positiveIcon from '@/assets/images/pages/positive-icon.png'
export default {
    components:{
        VueApexCharts
    },
    data(){
        return {

            //list topic
            listTopics: [],
            optionTopics: [],

            //list group topic
            optionGroupTopics: [],

            //list top post
            listTopPost: [],

            //percent mentioned
            percentMentioned: "",
            totalMentioned: 0,
            increaseMentioned: false,

            //title and content warning
            messageHeader:[],

            //show chart
            showRadialChart: false,
            showData: false,
            showTopTopic:false,
            //header table
            headerTable: [
                {name: this.$t('overview.topic').toUpperCase()},
                {name: this.$t('overview.project').toUpperCase()},
                {name: this.$t('overview.post').toUpperCase()},
                {name: this.$t('overview.positive').toUpperCase()},
                {name: this.$t('overview.negative').toUpperCase()}
            ],
            listTopDomain: [],
            defaultWords: [],
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    let date = new Date();
                    date.setDate(date.getDate() - 29);
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            radialChart: {
                series: [],
                chartOptions: {
                    chart: {
                    height: 200,
                    type: 'radialBar',
                    },
                    colors: [],
                    labels: [],
                    plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '18px',
                                show: true
                            },
                            value: {
                                fontSize: '16px',
                                color: '#5E5873'
                            },
                        }
                    }
                    },
                },
            }
        }
    },
    methods:{
        refreshData: function(){
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
            let fromDate = this.dateRange.startDate;
            let toDate = this.dateRange.endDate;

            let conditions = {
                from: fromDate,
                to: toDate,
                topicId: null,
                groupId: null,
                beanTypeSocial: [],
                topics:[]
            };
            this.getMentionTopic(conditions);
            this.getTopPostByClassification(conditions);
            this.getMention(conditions);
        },
        initScreen(){
            this.refreshData();
        },
        getTopicGroups: function(){
            return new Promise((resolve,reject) =>{
                this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
                this.optionGroupTopics = res.data;
                if(this.optionGroupTopics.length > 0){
                    this.optionGroupTopics = this.optionGroupTopics.map(el =>{
                    let background = el.color ? this.hexToRgbA(el.color, 0.15) : this.hexToRgbA('#007AFE', 0.15)
                    let circle = el.color ? this.hexToRgbA(el.color, 1) : this.hexToRgbA('#007AFE', 1)
                    return {
                        label:el.groupName,
                        value:el.id,
                        color: el.color ? el.color : '#007AFE',
                        bg: background,
                        circle: circle
                    }
                    })
                    let selecteAll = {label: 'Tất cả', value: null, color: '#007AFE', bg: background}
                    this.optionGroupTopics.unshift({label: 'Khác', value: null, color: '#007AFE', bg: background})
                    this.optionGroupTopics.sort(function(a ,b){
                    return b.value - a.value;
                    })
                    this.optionGroupTopics = [selecteAll].concat(this.optionGroupTopics);
                    resolve();
                }
            }).catch(() => reject())
            })
        },
        getTopic() {
        let conditions = {};
        this.$business
            .post("/topic/find-by-conditions", conditions)
            .then(topics => {
            this.$business.post(`share-topic/get-all-share`, conditions).then((res) =>{
                let listTopics = [...topics.data,...res.data.filter(item => item.status === 1)];
                this.optionTopics = listTopics;
                this.listTopics = listTopics;
                let result = null;
                let arrGroupTopic = this.optionGroupTopics;
                arrGroupTopic.forEach(filter => {
                result = this.optionTopics.filter(topic => topic.topicGroupId == filter.value)
                if(result < 1){
                    let index = arrGroupTopic.indexOf(filter);
                    this.optionGroupTopics.splice(index, 1);
                }
                })
                this.optionTopics.forEach(item => {
                if (item.favourite) {
                    this.searchByTopic(item)
                }
                if (item.topicName && item.topicName.length > 23){
                    item.topicName = item.topicName.slice(0,23) + '...';
                }
                if(!this.optionGroupTopics.find(el => el.value == item.topicGroupId)){
                item.isOther = true;
                }else{
                item.isOther = false;
                }
            });
            let selectedAll = {topicName: 'Tất cả', id: null};
            this.optionTopics = [selectedAll].concat(this.optionTopics);
            this.initScreen();
            })
            });
        },
        openURL: function(post){
            window.open(post.url,'_blank');
        },
        getMentionTopic(conditions) {
        this.$processor
            .post("/user-data/get-mention-topic", conditions)
            .then(topic => {
                this.defaultWords = topic.data.map(el => {
                    let object = {}
                    let findGroup = this.optionGroupTopics.find(item => item.value == el.topicGroupId);
                    if(!findGroup) { object['isOther'] = true; object['circle'] = "#007AFE"; object['groupName'] = this.$t('warningManager.other')}
                    else {object['isOther'] = false; object['circle'] = findGroup.circle; object['groupName'] = findGroup.label}
                    object['topicName'] = el.topicName;
                    object['count'] = el.countMention;
                    object['topicGroupId'] = el.topicGroupId;
                    object['positive'] = el.totalPositive;
                    object['negative'] = el.totalNegative;
                    object['checkPercent'] = false;
                    object['checkPercentNegative'] = false;
                    if (el.totalPositive > el.totalPositiveFrom) {
                        object['checkPercent'] = true;
                        object['percentPositive']= "+" +
                        (
                        ((el.totalPositive - el.totalPositiveFrom) /
                            (el.totalPositiveFrom != 0
                            ? el.totalPositiveFrom
                            : 1)) *
                        100
                        ).toFixed(0);
                    } else {
                        object['percentPositive'] = "-" +
                        (
                        ((el.totalPositiveFrom - el.totalPositive) /
                            (el.totalPositive!= 0
                            ? el.totalPositive
                            : 1)) *
                        100
                        ).toFixed(0);
                    }

                    if (el.totalNegative > el.totalNegativeFrom) {
                        object['checkPercentNegative'] = true;
                        object['percentNegative']= "+" +
                        (
                        ((el.totalNegative - el.totalNegativeFrom) /
                            (el.totalNegativeFrom != 0
                            ? el.totalNegativeFrom
                            : 1)) *
                        100
                        ).toFixed(0);
                    } else {
                        object['percentNegative'] = "-" +
                        (
                        ((el.totalNegativeFrom - el.totalNegative) /
                            (el.totalNegative!= 0
                            ? el.totalNegative
                            : 1)) *
                        100
                        ).toFixed(0);
                    }

                    if(el.keywords.length > 2){
                        object['plus'] = el.keywords.length - 2;
                        object['keywords']= el.keywords.map(k => k.keyword).slice(0,2).join(", ");
                    }
                    else{
                        object['keywords'] = el.keywords.map(k => k.keyword).join(", ");
                    }

                    let percentPost = 0;
                    if (el.totalPositive > el.totalNeutral && el.totalPositive > el.totalNegative){
                        percentPost = ((el.totalPositive / el.countMention) * 100).toFixed(0);
                        object['percent'] = !isNaN(percentPost) ? percentPost : 0;
                        object['color'] = "#28C76F";
                    if (el.totalNeutral > el.totalPositive && el.totalNeutral > el.totalNegative){
                        percentPost = ((el.totalNeutral / el.countMention) * 100).toFixed(0);
                        object['percent'] = !isNaN(percentPost) ? percentPost : 0;
                        object['color'] = "#FEC400";
                    }
                    if (el.totalNegative > el.totalPositive && el.totalNegative > el.totalNeutral){
                        percentPost = ((el.totalNegative / el.countMention) * 100).toFixed(0);
                        object['percent'] = !isNaN(percentPost) ? percentPost : 0;
                        object['color'] = "#EA5455";
                    }
                    }
                    return object;
                })
                this.defaultWords = this.defaultWords.sort((a, b) => {
                    return b.count - a.count;
                });
                this.showTopTopic = true;
            });
        },
        getMention(conditions) {
            let that = this;
            this.showRadialChart = false;
            this.$processor
                .post("/user-data/get-mention", conditions)
                .then(mention => {
            that.$processor
                .post("/user-data/get-shade", conditions)
                .then(shade => {
            this.mention = mention.data;
            this.totalMentioned = this.mention.totalMentioned;
            this.percentData = ((this.mention.totalMentioned / this.mention.countAllData) * 100).toFixed(0);
            this.percentMentioned = null;
            if (this.mention.countAllTo || this.mention.countAllFrom) {
                if (this.mention.countAllTo > this.mention.countAllFrom) {
                this.increaseMentioned = true;
                this.percentMentioned = "+" +
                    (
                    ((this.mention.countAllTo - this.mention.countAllFrom) /
                        (this.mention.countAllFrom != 0
                        ? this.mention.countAllFrom
                        : 1)) *
                    100
                    ).toFixed(2);
                } else {
                this.percentMentioned = "-" +
                    (
                    ((this.mention.countAllFrom - this.mention.countAllTo) /
                        (this.mention.countAllTo != 0
                        ? this.mention.countAllTo
                        : 1)) *
                    100
                    ).toFixed(2);
                }
            }
            that.shade = shade.data;
            that.radialChart.chartOptions.colors = [];
            that.radialChart.chartOptions.labels = [];
            let totalPositive =
                that.shade.totalPositiveSocialNetwork +
                that.shade.totalPositiveNews +
                that.shade.totalPositiveOther || 0;
            let totalNeutral =
                that.shade.totalNeutralSocialNetwork +
                that.shade.totalNeutralNews +
                that.shade.totalNeutralOther || 0;
            let totalNegative =
                that.shade.totalNegativeSocialNetwork +
                that.shade.totalNegativeNews +
                that.shade.totalNegativeOther || 0;
            let dataChart = null;
            that.messageHeader = [];
            if (totalPositive > totalNeutral && totalPositive > totalNegative) {
                that.radialChart.chartOptions.colors.push('#28C76F');
                dataChart = ((totalPositive / that.mention.totalMentioned)*100).toFixed(0);
                let message = {
                    title: this.$t('overview.greatNews'),
                    content: this.$t('overview.contentGreat'),
                    color: '#27AE60',
                    icon: positiveIcon,
                    vector: positive

                }
                that.radialChart.chartOptions.labels.push(this.$t('overview.positive'))
                that.messageHeader.push(message);
            }
            else if (totalNeutral > totalPositive && totalNeutral > totalNegative) {
                that.radialChart.chartOptions.colors.push('#FCA652');
                dataChart = ((totalNeutral / that.mention.totalMentioned)*100).toFixed(0);
                let message = {
                    title: this.$t('overview.caution'),
                    content: this.$t('overview.contentCaution'),
                    color: '#FCA652',
                    icon: neutralIcon,
                    vector: neutral
                }
                that.radialChart.chartOptions.labels = [(this.$t('overview.neutral'))]
                that.messageHeader.push(message);
            }
            else if (totalNegative > totalPositive && totalNegative > totalNeutral) {
                that.radialChart.chartOptions.colors.push('#FEC400');
                dataChart = ((totalNegative / that.mention.totalMentioned)*100).toFixed(0);
                let message = {
                    title: this.$t('overview.warning'),
                    content: this.$t('overview.contentWarning'),
                    color: '#F05454',
                    icon: warningIcon,
                    vector: warning

                }
                that.radialChart.chartOptions.labels.push(this.$t('overview.negative'))
                that.messageHeader.push(message)
            }
            else {
                that.radialChart.chartOptions.colors.push('#B8B5E1');
                dataChart = 0;
                let message = {
                    title: this.$t('overview.tip'),
                    content: this.$t('overview.contentTip'),
                    color: '#B8B5E1',
                    icon: tipIcon,
                    vector: tip

                }
                that.radialChart.chartOptions.labels.push(this.$t('overview.positive'))
                that.messageHeader.push(message)
            }
            that.radialChart.series = [dataChart];
            that.showRadialChart = true;
            });
            });
        },
        getTopPostByClassification: function(payload){
            this.$processor.post('/user-data/get-top-classification', payload).then((response) => {
                this.listTopPost = response.data;
                let index = 0;
                this.listTopPost = response.data.map(el => {
                    let totalClassification = el.positive + el.negative + el.normal;
                    let contennt = el.fullContents.filter(item => item.type == "text").map(text => {
                        if (text.content){
                           return text.content.trim();
                        }
                    }).join('\n')

                    let object = {};
                    object['stt'] = index++;
                    object['title']= el.title;
                    object['content'] = contennt;
                    object['value'] = totalClassification;
                    object['topicId'] = el.topicId;
                    object['keywords']= el.keywords;
                    object['interactive'] = el.specialFields.reactionCount;
                    object['share']  = el.specialFields.shareCount;
                    object['comment'] = el.specialFields.commentCount;
                    object['topicGroupId'] = el.topicGroupId;
                    object['url'] = el.url;
                    let percentPost = 0;

                    percentPost = ((el.positive / totalClassification) * 100).toFixed(0);
                    object['percentPositive'] = !isNaN(percentPost) ? parseInt(percentPost) : 0;
                    percentPost = ((el.normal / totalClassification) * 100).toFixed(0);
                    object['percentNeutral'] = !isNaN(percentPost) ? parseInt(percentPost) : 0;
                    percentPost = ((el.negative / totalClassification) * 100).toFixed(0);
                    object['percentNegative'] = !isNaN(percentPost) ? parseInt(percentPost) : 0;
                    if (el.positive > el.normal && el.positive > el.negative){
                        object['colorPositive'] = '#007AFE';
                        object['colorNegative'] = "#B9B9C3";
                        object['colorNeutral'] = '#B9B9C3';
                    }
                    if (el.normal > el.positive && el.normal > el.negative){
                        object['colorPositive'] = '#B9B9C3';
                        object['colorNegative'] = "#B9B9C3";
                        object['colorNeutral'] = '#FEC400';
                    }
                    if (el.negative > el.positive && el.negative > el.normal){
                        object['colorPositive'] = '#B9B9C3';
                        object['colorNegative'] = "#F12B2C";
                        object['colorNeutral'] = '#B9B9C3';
                    }
                    if (el.positive == el.negative && el.positive == el.neutral) {
                        object['colorPositive'] = '#007AFE';
                        object['colorNegative'] = "#FEC400";
                        object['colorNeutral'] = '#F12B2C';
                    }
                    return object;
                })
                this.showData = true;
            })
        },
        hexToRgbA:function(hex, opacity){
            var c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c= hex.substring(1).split('');
                if(c.length== 3){
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+ ','+ opacity +')';
            }
            throw new Error('Bad Hex');
        },
        eArabic: function(x) {
            return x ? x.toLocaleString("de-DE") : 0;
        },
    },
    async created(){
        this.getTopicGroups().then(() => {
            this.getTopic();
            this.refreshData();
        })
        this.initScreen();
        this.$eventBus.$on('i18n', () =>{
            this.initScreen();
        })
    },
    mounted(){
    }
}
</script>
<style lang="scss">
.cart-hightlight {
    min-height: 117px;
}
.cart-data {
    // height: 235px;
}
.cart-data-topic {
    // height: 400px;
    width: 336px;
}
.margin-top-overview{
    margin-top: -28px;
}
.topic-card {
    max-height: 400;
}
.text-data {
    font-size: 18px;
    color: #5E5873;
}
.count-sub-component {
    font-size: 14px;
    color: #5E5873;
}
.text-sub-component {
    font-size: 14px;
    // color: #B9B9C3;
    color:#5E5873
}
.text {
    font-size: 14px;
    color: #6E6B7B;
}
.count-data {
    font-size: 42px;
    color: #5E5873;
}
.min-button {
    min-width: 157px;
    width: max-content;
}
.text-keyword {
    font-size: 12px;
    color: #B9B9C3;
}
.text-group {
    font-size: 14px;
    color: #6E6B7B;
}
.text-content-keyword {
    font-size: 12px;
    color: #6E6B7B;
    min-height: 36px;
}
.shade-up {
    vertical-align: middle;
    color: #28C76F;
    width: 12px;
}
.percent-up {
    color: #28C76F;
}
.percent-down {
    color: #EA5455;
}
.shade-down {
    vertical-align: middle;
    color: #EA5455;
    width: 12px;
}
.bullet-align {
    display: inline-flex;
}
.m-top{
    margin-top: 4px;
}
.min-table .con-tablex .vs-con-tbody{
    height: 315px;
    z-index: 1;
}
.fixed-header{
  position: sticky;
  top: 0;
  background-color: #f8f8f8;
  z-index: 1000;
}
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
    font-weight: 400 !important;
}
.color-smile {
    // color: #007AFE;
    vertical-align: middle;
}
.color-negative {
    // color: #EA5455;
    vertical-align: middle;
}
.color-neutral {
    // color: #FEC400;
    vertical-align: middle;
}
.component svg {
    width: 30px;
    height: 30px;
}
.sub-component {
    display: grid !important;
    min-width: 70px;
    height: 50px;
}
.title-top-post {
    height: 54px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.content-top-post{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.title-header {
    font-size: 28px;
    color: #fff;
}
.content-header {
    font-size: 16px;
    color: #fff;
}
.table-topic {
    min-height: 430px;
}
.grid-cls {
    display: grid;
}
.custom-image-icon {
    position: absolute;
    height: 50px;
    top: -12px;
    left: 20px;
}
.custom-image-vector {
    position: absolute;
    width: 60px;
    bottom: 0px;
    left: 0px;
}
.min-height-topic {
    min-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
</style>
